import type { ImgHTMLAttributes } from 'react';

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  src: string;
  priority?: boolean;
};

export default function Image({ src, alt, width, height, className, priority, ...rest }: Props) {
  return (
    <img
      src={src}
      alt={alt ?? ''}
      width={width}
      height={height}
      className={className}
      loading={priority ? 'eager' : 'lazy'}
      decoding="async"
      {...rest}
    />
  );
}
